class FaqItem extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.button = this.querySelector('.Faq__Question');
    this.answer = this.querySelector('.Faq__AnswerWrapper');

    this.button?.addEventListener('click', () => this.#toggle(), { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  open() {
    document.querySelectorAll('faq-item.is-open').forEach((item) => {
      if (item !== this) item.close();
    });

    this.classList.add('is-open');
    this.button.setAttribute('aria-expanded', 'true');
    this.answer.setAttribute('aria-hidden', 'false');

    const height = this.answer.scrollHeight;
    this.answer.style.height = '0px';
    requestAnimationFrame(() => {
      this.answer.style.height = `${height}px`;
    });
  }

  close() {
    this.classList.remove('is-open');
    this.button.setAttribute('aria-expanded', 'false');
    this.answer.setAttribute('aria-hidden', 'true');
    this.answer.style.height = '0px';
  }

  #toggle() {
    if (this.classList.contains('is-open')) {
      this.close();
    } else {
      this.open();
    }
  }
}

class FaqSummary extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.querySelectorAll('.FaqSummary__Item').forEach((item) => {
      item.addEventListener('click', () => this.#activate(item), { signal });
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #activate(item) {
    this.querySelectorAll('.FaqSummary__Item.is-active').forEach((active) => active.classList.remove('is-active'));
    item.classList.add('is-active');
  }
}

if (!customElements.get('faq-item')) {
  customElements.define('faq-item', FaqItem);
}

if (!customElements.get('faq-summary')) {
  customElements.define('faq-summary', FaqSummary);
}
